export default class Media {
  id: string;
  AccID: 8;
  contentGroupId: string;
  name: string;
  originalMimetype: string;
  mimetype: string;
  duration: string;
  uploadedBy: string;
  uploadedAt: string;
  src: string;
  srcPreview: string;
  srcThumb: string;
  resX: number;
  resY: number;
  size: number;
  orientation: string;
  productUrl: string;

  constructor(
    id: string,
    AccID: 8,
    contentGroupId: string,
    name: string,
    originalMimetype: string,
    mimetype: string,
    duration: string,
    uploadedBy: string,
    uploadedAt: string,
    src: string,
    srcPreview: string,
    srcThumb: string,
    resX: number,
    resY: number,
    size: number,
    orientation: string,
    productUrl: string
  ) {
    this.id = id;
    this.AccID = AccID;
    this.contentGroupId = contentGroupId;
    this.name = name;
    this.originalMimetype = originalMimetype;
    this.mimetype = mimetype;
    this.duration = duration;
    this.uploadedBy = uploadedBy;
    this.uploadedAt = uploadedAt;
    this.src = src;
    this.srcPreview = srcPreview;
    this.srcThumb = srcThumb;
    this.resX = resX;
    this.resY = resY;
    this.size = size;
    this.orientation = orientation;
    this.productUrl = productUrl;
  }

  static fromObject(obj: {
    id: string;
    AccID: 8;
    contentGroupId: string;
    name: string;
    originalMimetype: string;
    mimetype: string;
    duration: string;
    uploadedBy: string;
    uploadedAt: string;
    src: string;
    srcPreview: string;
    srcThumb: string;
    resX: number;
    resY: number;
    size: number;
    orientation: string;
    productUrl: string;
  }) {
    return new Media(
      obj.id,
      obj.AccID,
      obj.contentGroupId,
      obj.name,
      obj.originalMimetype,
      obj.mimetype,
      obj.duration,
      obj.uploadedBy,
      obj.uploadedAt,
      obj.src,
      obj.srcPreview,
      obj.srcThumb,
      obj.resX,
      obj.resY,
      obj.size,
      obj.orientation,
      obj.productUrl
    );
  }

  clone() {
    return new Media(
      this.id,
      this.AccID,
      this.contentGroupId,
      this.name,
      this.originalMimetype,
      this.mimetype,
      this.duration,
      this.uploadedBy,
      this.uploadedAt,
      this.src,
      this.srcPreview,
      this.srcThumb,
      this.resX,
      this.resY,
      this.size,
      this.orientation,
      this.productUrl
    );
  }

  getGroup() {
	  return null;
  }

  setSrc(src: string) {
	  this.src = src;
  }

  setDuration(duration: string) {
	  this.duration = duration;
  }

}
